import { ResignationLinkPlacement } from 'app/shared/enums';

export const TRAVEL_RESIGNATION_LINK_CLICKED =
  'TRAVEL_RESIGNATION_LINK_CLICKED';

export const RESIGNATION_LINK_REDIRECT_TIMEOUT_MS = 2000;

export const travelResignationLinkClicked = (
  placement: ResignationLinkPlacement,
  onSent?: () => void
) => ({
  type: TRAVEL_RESIGNATION_LINK_CLICKED,
  payload: { placement, onSent },
});
